import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedSchema } from '../../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { widgetCodeSchema } from '../../../../validation/widgetCodeSchema.tsx';
import { CommonInputWidgetConfigSchema } from '../../common/CommonInputConfigComponent.tsx';
import { AdvancedSelectColumnDatatypes } from '../IAdvancedSelectColumns.ts';
import { isAdvancedSelectRichTextColumn } from './advancedSelectColumnOptions.ts';

/**
 * Schema di validazione comune per i widget di selezione avanzata
 * (singola e multipla)
 */
export const AdvancedSelectWidgetCommonConfigSchema =
  CommonInputWidgetConfigSchema.shape({
    modalTitle: RichTextAdvancedSchema.optional().label(
      'Titolo della finestra modale di selezione',
    ),
    buttonText: yup.string().label('Testo del pulsante di scelta').optional(),
    buttonTextAfter: yup
      .string()
      .label('Testo del pulsante di modifica dopo la scelta')
      .optional(),
    cancelButtonText: yup
      .string()
      .label('Testo del pulsante di cancellazione della scelta')
      .optional(),
    columns: yup
      .array(
        yup
          .object({
            id: widgetCodeSchema.label('ID Colonna'),
            label: yup.string().required().label('Etichetta Colonna'),
            type: yup
              .string()
              .oneOf(AdvancedSelectColumnDatatypes)
              .required()
              .label('Tipo di Dato'),
          })
          .required(),
      )
      .default(() => [])
      .min(1)
      .label('Colonne')
      .optional(),
    labelFieldColumns: yup
      .array(yup.string().required())
      .label('Colonne di Etichetta')
      .min(1)
      .required(),
    selectedLabelFieldColumns: yup
      .array(yup.string().required())
      .label('Colonne Visualizzate in Selezione')
      .optional(),
    placeholder: yup.string().label('Testo del placeholder').optional(),
    options: yup
      .array()
      .required()
      .default(() => []),
    uniqueValueColumnId: yup
      .string()
      .label('Colonna valore univoco')
      .min(1)
      .test(
        'not-rich-text-column',
        'La colonna valore univoco non può essere di tipo Testo formattato',
        function (value) {
          if (!value) return true;
          return !isAdvancedSelectRichTextColumn(this.parent?.columns, value);
        },
      )
      .required(),
  })
    .required()
    .noUnknown();
